export const getArchivedTrendNames = (archiveTrendsArr: unknown): string[] => {
  if (!Array.isArray(archiveTrendsArr)) return [];

  return archiveTrendsArr
    .map(item => {
      if (typeof item === "string") return item;
      if (item && typeof item === "object" && "name" in item) {
        return String((item as { name?: string }).name || "");
      }
      return "";
    })
    .filter(Boolean);
};

export const archivedTrendLabel = (order: string | number): string =>
  `Trend ${order}`;

export const filterArchivedGraphRows = <T>(
  rows: T[] | null | undefined,
  archivedNames: string[]
): T[] => {
  if (!rows?.length) return rows ?? [];
  if (!archivedNames.length) return rows;
  const archived = new Set(archivedNames);
  return rows.filter(row => {
    const tNo = (row as { tNo?: string | number }).tNo;
    return !archived.has(archivedTrendLabel(tNo ?? ""));
  });
};
